
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetoindorecabs() {



    const cardData =
    {
        keyword: '  Pune to Indore Cabs',
        heading: 'Mauli Cabs: Pune to Indore Cabs',
        headingDescription: 'Mauli Cabs offers reliable and comfortable Pune to Indore cabs, ensuring a smooth and pleasant journey to the vibrant city of Indore. Whether you are traveling for business, leisure, or a special occasion, we provide a range of vehicles including sedans, SUVs, and premium cars to meet your needs. With professional drivers, transparent pricing, no hidden charges, and a commitment to customer satisfaction, Mauli Cabs guarantees a hassle-free and enjoyable ride from Pune to Indore.',

        top: 'Top Places to Visit in Indore with Mauli Cabs',

"topPlaces": [
    {
        "title": "Rajwada Palace",
        "description": "Rajwada Palace is an iconic historical landmark in Indore, known for its grandeur and beautiful architecture. The palace blends Maratha, Mughal, and Holkar styles, and is an important symbol of Indore's royal history."
    },
    {
        "title": "Lal Baag Palace",
        "description": "Lal Baag Palace is another royal residence in Indore, showcasing the opulence of the Holkar dynasty. The palace is surrounded by well-maintained gardens and features exquisite architecture with lush interiors."
    },
    {
        "title": "Indore Museum",
        "description": "Indore Museum is a fascinating place for history lovers. It houses a vast collection of artifacts, sculptures, and paintings that reflect the rich cultural heritage of the region, including items from the Maratha and Mughal periods."
    },
    {
        "title": "Kanch Mandir",
        "description": "Kanch Mandir is a Jain temple known for its stunning architecture made entirely of glass. The temple’s interior is mesmerizing, with glass mosaics and mirrors creating a radiant ambiance."
    },
    {
        "title": "Sarafa Bazar",
        "description": "Sarafa Bazar is a popular street food market in Indore, famous for its late-night food stalls offering a variety of delicious street snacks like poha, samosas, jalebi, and bhutte (corn). It’s a must-visit for food lovers."
    },
    {
        "title": "Annapurna Temple",
        "description": "Annapurna Temple is a significant Hindu temple dedicated to Goddess Annapurna. Located on the Annapurna Road, the temple is known for its peaceful environment and beautiful architecture, making it a popular pilgrimage site."
    },
    {
        "title": "Chappal Bazaar",
        "description": "Chappal Bazaar is a unique market in Indore known for its wide variety of footwear at reasonable prices. It is a great place to shop for handmade shoes and slippers, as well as leather goods."
    },
    {
        "title": "Patalpani Waterfall",
        "description": "Located about 35 km from Indore, Patalpani Waterfall is a popular weekend getaway. The waterfall is surrounded by lush greenery and provides an ideal spot for nature lovers, photographers, and trekkers."
    },
    {
        "title": "Mahakaleshwar Temple",
        "description": "Mahakaleshwar Temple is a sacred Hindu temple dedicated to Lord Shiva. It is located near Indore and is renowned for its architectural beauty and spiritual significance, attracting thousands of pilgrims every year."
    },
    {
        "title": "Tincha Waterfall",
        "description": "Tincha Waterfall is a stunning natural waterfall located around 25 km from Indore. It is a peaceful spot amidst lush green forests, ideal for picnics, trekking, and photography, especially during the monsoon season."
    }
],

"services": [
    {
      "name": "Pune to Indore Taxi Services",
      "description": "Book a reliable taxi service from Pune to Indore for a comfortable and safe journey."
    },
    {
      "name": "Pune to Indore Cab Booking",
      "description": "Easily book a cab for your trip from Pune to Indore online with flexible options."
    },
    {
      "name": "Pune to Indore Car Rental",
      "description": "Rent a car from Pune to Indore and travel at your own pace with a variety of vehicle options."
    },
    {
      "name": "Pune to Indore Rajwada Palace Cabs",
      "description": "Book a taxi service specifically for your visit to the historic Rajwada Palace in Indore."
    },
    {
      "name": "Pune to Indore One-Way Taxi",
      "description": "Get a one-way taxi service from Pune to Indore for a convenient one-way journey."
    },
    {
      "name": "Pune to Indore Round Trip Cabs",
      "description": "Book a round trip cab service from Pune to Indore, ideal for those looking to return the same day."
    },
    {
      "name": "Pune to Indore Luxury Taxi",
      "description": "Choose a luxury taxi for your trip from Pune to Indore for a premium travel experience."
    },
    {
      "name": "Pune to Indore Self-Drive Car Rental",
      "description": "Rent a self-drive car for a flexible and independent travel experience from Pune to Indore."
    },
    {
      "name": "Pune to Indore Private Car Hire",
      "description": "Hire a private car for a comfortable and personalized journey from Pune to Indore."
    },
    {
      "name": "Pune to Lal Bagh Palace",
      "description": "Book a cab to visit the famous Lal Bagh Palace in Indore, a prominent historical landmark."
    },
    {
      "name": "Pune to Indore Cab",
      "description": "Book a general cab service from Pune to Indore for your travel needs."
    },
    {
      "name": "One Way Cab Pune to Indore",
      "description": "Get a one-way cab service from Pune to Indore with competitive rates and easy booking."
    },
    {
      "name": "Pune to Indore Cab Service",
      "description": "Reliable cab service from Pune to Indore for comfortable, timely, and safe travel."
    },
    {
      "name": "Pune to Indore Taxi",
      "description": "Book a taxi from Pune to Indore with a variety of vehicle options."
    },
    {
      "name": "Pune to Indore Ertiga Cab",
      "description": "Rent a spacious Maruti Ertiga cab for your trip from Pune to Indore, suitable for small families or groups."
    },
    {
      "name": "Pune to Indore Innova Crysta",
      "description": "Opt for the luxury Innova Crysta for a comfortable, premium ride from Pune to Indore."
    },
    {
      "name": "Pune to Indore Sedan Cab Services",
      "description": "Book a sedan cab service for a smooth and comfortable journey from Pune to Indore."
    },
    {
      "name": "Pune to Indore Swift Dzire on Rent",
      "description": "Rent a Swift Dzire for an economical yet comfortable travel experience from Pune to Indore."
    }
  ],
  "tableData": [
    ["Pune to Indore Taxi Services", "Pune to Indore Cab Booking"],
    ["Pune to Indore Car Rental", "Pune to Indore Rajwada Palace Cabs"],
    ["Pune to Indore One-Way Taxi", "Pune to Indore Round Trip Cabs"],
    ["Pune to Indore Luxury Taxi", "Pune to Indore Self-Drive Car Rental"],
    ["Pune to Indore Private Car Hire", "Pune to Lal Bagh Palace"],
    ["Pune to Indore Cab", "One Way Cab Pune to Indore"],
    ["Pune to Indore Cab Service", "Pune to Indore Taxi"],
    ["Pune to Indore Ertiga Cab", "Pune to Indore Innova Crysta"],
    ["Pune to Indore Sedan Cab Services", "Pune to Indore Swift Dzire on Rent"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs offers reliable and timely service for your Pune to Indore journey. Whether you're traveling for business or leisure, our professional drivers ensure punctual pickups and drop-offs, ensuring you reach your destination on time."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "For your Pune to Indore trip, we offer a range of comfortable and spacious vehicles. Whether you need a sedan, SUV, or premium car, all our vehicles are air-conditioned, well-maintained, and designed for a smooth and enjoyable ride."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced and professional drivers are familiar with the best routes from Pune to Indore. They ensure a smooth, safe, and efficient journey, avoiding traffic and ensuring you have a relaxing trip to Indore."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers affordable and transparent pricing for your Pune to Indore cab ride. There are no hidden charges, and we provide clear, upfront pricing so you can enjoy a comfortable journey without worrying about the cost."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our priority. All our vehicles are equipped with modern safety features like airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols to ensure a secure and comfortable ride to Indore."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available 24/7 for your Pune to Indore trip. Whether you need an early morning pickup or a late-night return, our customer service team is always available to assist you with your booking and travel needs."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Indore cab with Mauli Cabs is quick and easy. You can book your ride online through our website or mobile app, or contact our customer service team for personalized assistance, ensuring a smooth and hassle-free booking process."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Mauli Cabs offers customized travel packages for your Pune to Indore journey. Whether you're traveling for business, leisure, or a group tour, we can tailor the service to meet your specific needs, ensuring a pleasant and memorable trip."
    }
]























    }


    const faqData = [
        {
            question: 'How do I book a cab from Pune to Indore with Mauli Cabs?',
            answer: 'Booking a cab from Pune to Indore with Mauli Cabs is simple! You can book directly through our website or mobile app by entering "Pune" as your pickup location and "Indore" as your destination. Choose your preferred vehicle, confirm the booking, and you’re good to go. Alternatively, you can contact our customer support team for assistance.',
        },
        {
            question: 'What types of cabs are available for the Pune to Indore trip?',
            answer: 'Mauli Cabs offers a variety of vehicles for your Pune to Indore journey, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. You can select a vehicle based on your space and comfort preferences.',
        },
        {
            question: 'Is the fare for the Pune to Indore trip fixed?',
            answer: 'Yes, the fare for the Pune to Indore trip is fixed and transparent. The fare includes all charges such as tolls, taxes, driver fees, and other applicable charges. There are no hidden costs, and you will know the total fare upfront at the time of booking.',
        },
        {
            question: 'Can I book a round trip for the Pune to Indore journey?',
            answer: 'Yes, you can easily book a round trip from Pune to Indore. Simply provide your return details during booking, and we will ensure a smooth return journey for you.',
        },
        {
            question: 'How long does the journey from Pune to Indore take?',
            answer: 'The journey from Pune to Indore typically takes about 7 to 8 hours, depending on traffic and road conditions. The route offers scenic views and a comfortable driving experience, ensuring a pleasant long-distance trip.',
        },
        {
            question: 'Are the drivers experienced for the Pune to Indore trip?',
            answer: 'Yes, all Mauli Cabs drivers are highly professional, experienced, and familiar with the best routes to Indore. They ensure a safe and timely journey while prioritizing your comfort.',
        },
        {
            question: 'Can I make stops during my journey from Pune to Indore?',
            answer: 'Yes, you can make stops during the journey for meals, refreshments, or sightseeing. Our drivers will accommodate any requests to ensure your journey is as comfortable and enjoyable as possible.',
        },
        {
            question: 'Are the cabs air-conditioned and well-maintained for the Pune to Indore trip?',
            answer: 'Yes, all our cabs are air-conditioned and thoroughly maintained to ensure a smooth and comfortable ride. We prioritize cleanliness and comfort for a pleasant journey.',
        },
        {
            question: 'Can I cancel or modify my booking for the Pune to Indore trip?',
            answer: 'Yes, you can easily cancel or modify your booking for the Pune to Indore trip. We offer flexible cancellation and modification policies via our website or app, and our customer support team is ready to assist you.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Indore trip?',
            answer: 'Mauli Cabs offers competitive pricing, a variety of vehicle options, experienced drivers, and a commitment to ensuring your safety and comfort. Whether you’re traveling for business, leisure, or a long road trip, we ensure a stress-free and enjoyable journey to Indore.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Vikram Singh",
            position: "Business Traveler",
            text: "I recently traveled from Pune to Indore with Mauli Cabs, and the entire experience was fantastic. The car was comfortable, well-maintained, and the driver was highly professional. The journey was smooth and enjoyable. I highly recommend Mauli Cabs for long-distance travel.",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Radhika Patel",
            position: "Leisure Traveler",
            text: "My trip from Pune to Indore was a pleasant one with Mauli Cabs. The vehicle was spacious, the air conditioning was perfect, and the ride was smooth throughout. The driver was courteous, and the trip was well-organized. I will definitely choose Mauli Cabs for my future trips.",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Indore Cab Booking by Mauli Cabs",
        "description": "Mauli Cabs offers reliable and affordable taxi services for your journey from Pune to Indore. Choose from private cars, luxury taxis, or group travel options like Ertiga, Innova Crysta, and Swift Dzire. Whether you need a one-way or round-trip journey, we provide the best travel experience with comfort and convenience.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "4100"
        }
      };
      
      
      

    return (
        <div>
            <GTag/>


<Helmet>
        <title>Pune to Indore Cab Booking | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book your Pune to Indore cab with Mauli Cabs. Choose from a range of vehicles like luxury cabs, Ertiga, Innova Crysta, and Swift Dzire for a comfortable journey. Enjoy a smooth ride with one-way or round-trip options, and explore Indore's attractions like Rajwada Palace and Lal Bagh Palace."
        />
        <meta
          name="keywords"
          content="Pune to Indore Taxi Services, Pune to Indore Cab Booking, Pune to Indore Car Rental, Pune to Indore Rajwada Palace Cabs, Pune to Indore One-Way Taxi, Pune to Indore Round Trip Cabs, Pune to Indore Luxury Taxi, Pune to Indore Self-Drive Car Rental, Pune to Indore Private Car Hire, Pune to Lal Bagh Palace, Pune to Indore Cab, One Way Cab Pune to Indore, Pune to Indore Cab Service, Pune to Indore Taxi, Pune to Indore Ertiga Cab, Pune to Indore Innova Crysta, Pune to Indore Sedan Cab Services, Pune to Indore Swift Dzire on Rent"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>

            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/47.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoindorecabs;